import { Target } from "@vytant/stimulus-decorators";
import ApplicationController from "./application_controller";

export default class TitleSuggestionsController extends ApplicationController {
  @Target titleInputTarget!: HTMLInputElement;

  use(event: StimulusEvent<{ title: string }>) {
    this.titleInputTarget.value = event.params.title;
    this.titleInputTarget.innerHTML = event.params.title;
  }
}
